import { createWebHistory, createRouter } from "vue-router";
import routes from './routes';

const router = createRouter({
  history: createWebHistory(),
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, left: 0 };
    }
  },
});
router.beforeEach((to, from, next) => {
  if (to.meta.public)
    return



  const authLocal = localStorage.getItem('token')
  const authSession = sessionStorage.getItem('token')

  const isAuthorized = Boolean(authLocal || authSession)

  if (isAuthorized && (to.path === '/login' || to.path === '/register' || to.path === '/verification-code' || to.path === '/forgot-password' || to.path === '/reset-password'))
    window.location.href = '/'

  if (!isAuthorized && (to.path === '/login' || to.path === '/register' || to.path === '/verification-code' || to.path === '/forgot-password' || to.path === '/reset-password'))
    return next()

  if (!isAuthorized) {
    // Save intended path
    localStorage.setItem('redirectPath', to.fullPath)
    return next('/login')
  }
  next(true)



})

export default router;
